import { UAParser } from "ua-parser-js"

const COLUMN_LENGTH = 64
const UNIDENTIFIED = "unknown"

const fit = (value: string): string => (value.length > COLUMN_LENGTH ? value.slice(0, COLUMN_LENGTH) : value)

interface DeviceIdentity {
  id: string
  manufacturer: string
  model: string
}

const deviceIdentity = (deviceId: string, userAgent: string | null | undefined): DeviceIdentity => {
  const { device, os, browser } = UAParser(userAgent ?? "")

  return {
    id: fit(deviceId),
    manufacturer: fit(device.vendor ?? os.name ?? UNIDENTIFIED),
    model: fit(device.model ?? browser.name ?? UNIDENTIFIED),
  }
}

export const deviceHeaders = (deviceId: string | null | undefined, userAgent: string | null | undefined): Record<string, string> => {
  if (!deviceId) return {}

  const { id, manufacturer, model } = deviceIdentity(deviceId, userAgent)

  return { "x-device-id": id, "x-device-manufacturer": manufacturer, "x-device-model": model }
}
